import { Installation } from 'src/Libs/installations/models/installation.model'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { InstallationsApiView } from 'src/Libs/installations/components/InstallationsApiView'
import { errorInstallationsFetchProps, getRequireAttentionCustomFunctionalities } from 'src/Libs/installations/utils/installation-table-columns'
import { setActiveInstallationAndStorage } from 'src/Libs/installations/installation.functions'
import { CustomFunctionalitiesButtonVariants } from 'src/Libs/installations/types'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useMediaQuery, useTheme } from '@mui/material'
import { Breakpoints } from 'src/Configuration/breakpoints'
import { BlankViewImageVariants, BlankView, BlankViewImageSizes } from 'src/Components/blank-view'
import { getSystemProtocolUrl } from 'src/Libs/system-status'

interface InstallationsWithAttentionProps {
  showStatusColumn?: boolean
  onSelect: (installation?: Installation) => void
}

/**
 * Component in to display the installations that require the user's attention in the overview
 */
const InstallationsWithAttention: React.FC<InstallationsWithAttentionProps> = ({ showStatusColumn = false, onSelect }) => {
  const { t } = useCustomTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down(Breakpoints.Mobile))

  const requireAttentionCustomFunctionalities = getRequireAttentionCustomFunctionalities(
    t,
    (installation: Installation) => {
      setActiveInstallationAndStorage(installation, dispatch)
      navigate(getSystemProtocolUrl(installation.id, installation.emsMasterDeviceId))
    },
    downSm ? CustomFunctionalitiesButtonVariants.Icon : CustomFunctionalitiesButtonVariants.Button
  )

  return (
    <InstallationsApiView
      keyValue={1}
      fetchProps={errorInstallationsFetchProps}
      dataQaPrefix={'installations-attention'}
      customFunctionalities={requireAttentionCustomFunctionalities}
      onSelect={onSelect}
      onSelectOnlyInList
      showStatus={showStatusColumn}
      blankView={
        <BlankView
          imageVariant={BlankViewImageVariants.Happy}
          imageSize={BlankViewImageSizes.Small}
          title={'companyDashboard.blank-view.require-attention-installation.title'}
          explanation={'companyDashboard.blank-view.require-attention-installation.explanation'}
          fullHeight
        />
      }
    />
  )
}

export default InstallationsWithAttention
